// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"1973d110","453":"ee4b7ed1","834":"e8b417bb"}[chunkId] + ".chunk.js";
};